import {Action} from "@ngrx/store";
import {IWorkspaceSwitcherState} from "../reducers/workspace-switcher.reducer";

export const SWITCH_WORKSPACE: string = '[workspace] Switch Workspace';
export const SWITCH_WORKSPACE_SUCCESS: string = '[workspace] Switch Workspace Success';
export const SWITCH_WORKSPACE_FAIL: string = '[workspace] Switch Workspace Fail';

export class SwitchWorkspace implements Action {
  readonly type = SWITCH_WORKSPACE;

  constructor(public payload: IWorkspaceSwitcherState) {}
}

export class SwitchWorkspaceActivity implements Action {

  readonly type: string = SWITCH_WORKSPACE;

}

export class SwitchWorkspaceSuccess implements Action {

  readonly type: string = SWITCH_WORKSPACE_SUCCESS;
  constructor(public payload: IWorkspaceSwitcherState) {}

}

export class SwitchWorkspaceFail implements Action {

  readonly type: string = SWITCH_WORKSPACE_FAIL;
  constructor(public payload: string) {}

}

export type WorkspaceSwitcherAction = SwitchWorkspace | SwitchWorkspaceSuccess | SwitchWorkspaceFail;
